export default __webpack_public_path__ + "static/media/Deepiq_chart (5).9f87d2d6.png";